<div class="flex flex-row text-xs">
  <app-usercombi-from-to [userCombi]="userCombi()"></app-usercombi-from-to>
  <div class="grow ml-5 pt-1 text-right">
    <span class="usercombi-selection-queue" translate="PAGE_DASHBOARD_USERCOMBI_CAN_CALCULATE_QUEUE_SIZE"></span>
  </div>
</div>
